import { render, staticRenderFns } from "./Maquina.vue?vue&type=template&id=214a7c05&"
import script from "./Maquina.vue?vue&type=script&lang=js&"
export * from "./Maquina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports